import React from "react";
import PropTypes from "prop-types";

function AreaDirectorDigitalJobsIndex(props) {
  const formatDate = str => str ? (new Date(Date.parse(str)).toLocaleDateString("en-US", { year: "2-digit", month: "2-digit", day: "2-digit" })) : "";
  const formatTime = str => str ? (new Date(Date.parse(str)).toLocaleTimeString('en-US')) : "";

  const rows = props.data.map(job => (
    <a key={job.index} className="list-group-item u-hover--raised" href={job.href}>
      <div className="d-flex w-100 align-items-center cursor-pointer row">
        <div className={`list-status-side-bar ${job.color_class}`} title={job.color_status_in_words} />
        <div className="d-flex flex-column col-1 m-0 pl-2 pl-md-3 u-ta-center">
            <i className={`material-icons ${job.status_icon_color}-text ${job.show_status_icon == true ? 'd-block' : 'd-none'}`} aria-label={job.status_icon_title} title={job.status_icon_title}>{job.status_icon}</i>
        </div>
        <div className="d-flex flex-column col-5 col-sm-4 col-md-3 grey-text text-darken-3">
          {job.client_name}
          <small className={`grey-text text-darken-2 ${job.status === "Complete" ? 'd-none' : 'd-block'}`}>{job.color_status_in_words}</small>
        </div>

        <small className="d-none d-sm-flex flex-column col-2 grey-text text-darken-2 col">
          {job.social_ad_type}
        </small>

        <small className="d-none d-lg-flex flex-column grey-text text-darken-2 col-2 u-wrap">
          {job.territories}
        </small>

        <small className="d-none d-sm-flex flex-column grey-text text-darken-2 col-3 col-sm-4 col-md-3 col-lg-2 u-wrap">
          {job.publications}
        </small>

        <small className="d-none d-md-flex flex-column grey-text text-darken-2 col-2 col-lg-1" title={formatTime(job.display_date)}>
          {formatDate(job.display_date)}
        </small>

        <div className="d-flex grey-text text-darken-2 flex-column col-1 align-items-center ml-auto">
          <i className="material-icons">keyboard_arrow_right</i>
        </div>
      </div>
    </a>
  ));

  return (
    <ul className="list-group list-group-flush mb-6">
      <div className="list-group-item pt-3">
        <div className="d-flex row w-100 fw-bold">
          <h5 className="d-flex flex-column col-1 pl-2 pl-md-3 m-0"></h5>
          <h5 className="d-flex col-5 col-sm-4 col-md-3 u-wrap">Client Name</h5>
          <h5 className="d-none d-sm-flex col-2 u-wrap">Job Type</h5>
          <h5 className="d-flex col-2 u-wrap d-none d-lg-block">Territories</h5>
          <h5 className="d-none d-sm-flex col-3 col-sm-4 col-md-3 col-lg-2">Publications</h5>
          <h5 className="d-none d-md-flex col-2 col-lg-1 pr-0">{props.dateColumnTitle}</h5>
          <div className="d-flex col-1 flex-column align-items-center"></div>
        </div>
      </div>
      {rows}
    </ul>
  );
}

AreaDirectorDigitalJobsIndex.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    client_name: PropTypes.string.isRequired,
    color_class: PropTypes.string.isRequired,
    color_status_in_words: PropTypes.string.isRequired,
    facebook_approval: PropTypes.string.isRequired,
    formatted_modified_at: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    publications: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    status_icon: PropTypes.string.isRequired,
    status_icon_color: PropTypes.string.isRequired,
    status_icon_title: PropTypes.string.isRequired,
    territories: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
    show_status_icon: PropTypes.string.isRequired,
    completed_on: PropTypes.string.isRequired,
    formatted_completed_on: PropTypes.string.isRequired,
    modified_at: PropTypes.string.isRequired,
    display_date: PropTypes.string.isRequired,
  })).isRequired,
  dateColumnTitle: PropTypes.string.isRequired,
};

export default AreaDirectorDigitalJobsIndex;
